import script from "./PageReports.vue?vue&type=script&setup=true&lang=js"
export * from "./PageReports.vue?vue&type=script&setup=true&lang=js"

import "./PageReports.vue?vue&type=style&index=0&id=0fbf0456&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fbf0456"]])

export default __exports__